import {
  Component,
  EnvironmentInjector,
  inject,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { IconService } from '@services/icon.service';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NavigationComponent } from '@components/navigation/navigation.component';
import { SideNavigationComponent } from '@components/side-navigation/side-navigation.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { OidcSecurityService } from 'angular-auth-oidc-client';

import {
  AbstractTableViewsService,
  ComponentPortalComponent,
  ComponentPortalService,
  ConfigService,
  LibraryInjector,
  ngxMatDateFormats,
  OauthService,
} from '@tiltgroup/web-components';
import { TableViewsService } from '@services/queries/services/table-views.service';
import { environment } from '@environments/environment';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'lig-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    MatIconModule,
    MatCheckboxModule,
    NavigationComponent,
    SideNavigationComponent,
    MatDialogModule,
    MatSnackBarModule,
    RouterModule,
    MatSidenavModule,
    MatButtonModule,
    ComponentPortalComponent,
  ],
  providers: [
    { provide: AbstractTableViewsService, useClass: TableViewsService },
    {
      provide: MAT_DATE_FORMATS,
      useValue: ngxMatDateFormats,
    },
  ],
})
export class AppComponent implements OnInit {
  static injector: Injector;
  private _iconService = inject(IconService);
  private _injector = inject(EnvironmentInjector);

  private _oauthService = inject(OauthService);
  private _oidcSecurityService = inject(OidcSecurityService);

  private _configService = inject(ConfigService);
  private _componentPortalService = inject(ComponentPortalService);

  @ViewChild('drawer', { static: true })
  drawer!: MatDrawer;

  constructor() {
    AppComponent.injector = this._injector;
    LibraryInjector.setInjector(this._injector);
    this._configService.setUpEnvironment(environment);
  }

  ngOnInit() {
    this._oidcSecurityService.getConfiguration().subscribe((res) => {
      this._oauthService.authConfig = res;
      this._oauthService.subscribeToEvents();
      this._oauthService.checkAuth();
    });

    this._componentPortalService.initializeDrawerRef(this.drawer);
  }
}
